export function environmentApiUrl() {
  return `${window.location.origin}/webui-bff/api`;
}
